import React from 'react';

// SVG pitch zone map component
const PitchZoneMap: React.FC<{
  zones: Record<string, { count: number; label?: string; color: string; opacity: number }>;
  title: string;
}> = ({ zones, title }) => {
  // Zone grid positions: x zones (def=0-33, mid=33-67, att=67-100), y zones (left=0-33, center=33-67, right=67-100)
  const zonePositions: Record<string, { x: number; y: number; w: number; h: number }> = {
    'def-left':    { x: 0,    y: 0,    w: 33.3, h: 21.67 },
    'def-center':  { x: 0,    y: 21.67, w: 33.3, h: 21.67 },
    'def-right':   { x: 0,    y: 43.33, w: 33.3, h: 21.67 },
    'mid-left':    { x: 33.3, y: 0,    w: 33.4, h: 21.67 },
    'mid-center':  { x: 33.3, y: 21.67, w: 33.4, h: 21.67 },
    'mid-right':   { x: 33.3, y: 43.33, w: 33.4, h: 21.67 },
    'att-left':    { x: 66.7, y: 0,    w: 33.3, h: 21.67 },
    'att-center':  { x: 66.7, y: 21.67, w: 33.3, h: 21.67 },
    'att-right':   { x: 66.7, y: 43.33, w: 33.3, h: 21.67 },
  };

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{title}</p>
      <svg viewBox="0 0 100 65" className="w-full border border-gray-300 dark:border-gray-600 rounded bg-green-900/10 dark:bg-green-900/20">
        {/* Pitch outline */}
        <rect x="0" y="0" width="100" height="65" fill="none" stroke="#4a7c4f" strokeWidth="0.5" />
        {/* Center line */}
        <line x1="50" y1="0" x2="50" y2="65" stroke="#4a7c4f" strokeWidth="0.3" />
        {/* Center circle */}
        <circle cx="50" cy="32.5" r="9" fill="none" stroke="#4a7c4f" strokeWidth="0.3" />
        {/* Left penalty area */}
        <rect x="0" y="13" width="17" height="39" fill="none" stroke="#4a7c4f" strokeWidth="0.3" />
        {/* Left goal area */}
        <rect x="0" y="22" width="6" height="21" fill="none" stroke="#4a7c4f" strokeWidth="0.3" />
        {/* Right penalty area */}
        <rect x="83" y="13" width="17" height="39" fill="none" stroke="#4a7c4f" strokeWidth="0.3" />
        {/* Right goal area */}
        <rect x="94" y="22" width="6" height="21" fill="none" stroke="#4a7c4f" strokeWidth="0.3" />

        {/* Zone rectangles */}
        {Object.entries(zonePositions).map(([zoneName, pos]) => {
          const zoneData = zones[zoneName];
          if (!zoneData) return null;
          return (
            <g key={zoneName}>
              <rect
                x={pos.x}
                y={pos.y}
                width={pos.w}
                height={pos.h}
                fill={zoneData.color}
                opacity={zoneData.opacity}
                stroke="#4a7c4f"
                strokeWidth="0.2"
              />
              <text
                x={pos.x + pos.w / 2}
                y={pos.y + pos.h / 2 - 1.5}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="3.5"
                fontWeight="bold"
                fill="white"
                className="drop-shadow-sm"
              >
                {zoneData.count}
              </text>
              {zoneData.label && (
                <text
                  x={pos.x + pos.w / 2}
                  y={pos.y + pos.h / 2 + 3}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="2.5"
                  fill="white"
                  opacity={0.9}
                >
                  {zoneData.label}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default PitchZoneMap;
